
  
    <template #toggler>
      <CDropdownHeader >        
          <CButton id="sair" v-on:click="logout"> <CIcon name="cilAccountLogout" /> Sair </CButton>        
      </CDropdownHeader>
    
    
  
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'TheHeaderDropdownAccnt',
    
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.go({ path: this.$router.path });
        });
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }

  #sair:hover {
      color: #002;
  }
</style>